import React from 'react';
import { PrimaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import { standardRequestWithFlash } from 'shared/utils/request';
import { Person } from 'talent_matching/types';
import useQueryHelper from 'talent_matching/hooks/use_query_helper';
import { useAdvancedCandidateCount } from 'talent_matching/contexts/advanced_candidate_count_context';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';

const t = withLocalePrefix('talent_matching');

type Props = {
  application: Person;
  canAdvance?: boolean;
  onSuccess?: () => void;
};

const AdvanceButton = ({
  application,
  canAdvance = true,
  onSuccess,
}: Props) => {
  const { excludePeople } = useQueryHelper();
  const { onAdvanceSuccess } = useAdvancedCandidateCount();
  const { appReviewSessionId } = useTalentMatchingTabContext();
  const handleAdvance = async () => {
    if (!application.advancePath) {
      return;
    }
    try {
      await standardRequestWithFlash.post(application.advancePath, {
        app_review_session_id: appReviewSessionId,
        source: 'talent_matching',
        action_source: 'side_panel',
      });
      excludePeople([application.id]);

      if (onSuccess) {
        onSuccess();
      }
      onAdvanceSuccess(application);
    } catch {
      return;
    }
  };

  return (
    <PrimaryButton onClick={handleAdvance} size="md" disabled={!canAdvance}>
      {t('advance')}
    </PrimaryButton>
  );
};

export default AdvanceButton;
